<template>
  <div class="portlet-container fixed-filter">
      <div class="content-container" style="height: 100%;">
        <div class="flex-auto-column" style="height: 100%;">

          <template v-if="withHeader">
              <div class="filter-container" style="margin: 0rem;">
                <slot name="header">
                  <el-button size="small" class="left floated labeled icon button" icon="plus">Submit</el-button>
                </slot>
              </div>
          </template>

          <div style="height: 100%; overflow: auto; padding: 1rem;">
            <slot></slot>
          </div>

          <template  v-if="withFooter">
            <footer class="ui cleared floated footer-container">
              <el-button size="small" class="right floated labeled icon button" icon="plus">Submit</el-button>
            </footer>
          </template>

        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'content',
  data () {
    return {
      withFooter: false
    }
  },
  methods: {
    hasSlot (name = 'default') {
      console.log('this.$slots %o', this.$slots)
      return !!this.$slots[ name ] || !!this.$scopedSlots[ name ]
    }
  },
  computed: {
    withHeader () {
      console.log('withHeader check ')
      return this.hasSlot('header')
    },
    portletContainerClass () {
      return this.type === 2 || this.type === 3 ? 'fixed-filter' : ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .portlet-container {
    padding: 0rem;
  }
  .content-container {
    margin: 0rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/PortletContainer.vue